import React from 'react';
import PageLayout from '@/components/layout/PageLayout';
import CommunityPage from '@/pages/CommunityPage';

const CommunityPageWithLayout: React.FC = () => {
  return (
    <PageLayout showComposer={false} hidePostButtons={true} pageTitle="Community">
      <CommunityPage />
    </PageLayout>
  );
};

export default CommunityPageWithLayout;
